<template>
    <div
        class="loader"
        :class="loadingClasses"
        :style="{'min-height': minHeight ? `${minHeight}px` : null}">
        <div class="loader__content">
            <div class="loader__spinner"></div>
            <p
                class="loader__message"
                v-if="message"
                v-text="message"
            ></p>
        </div>
    </div>
</template>

<script>
    export default {
        name: 'loading_spinner',
        props: {
            transition: {
                type: String,
                required: false,
                default: 'fade'
            },
            transparent: {
                type: Boolean,
                required: false,
                default: false
            },
            message: {
                type: String,
                required: false
            },
            minHeight: {
                type: Number,
                required: false
            }
        },
        computed: {
            loadingClasses () {
                return {
                    'transparent': this.transparent
                }
            }
        }
    }
</script>

<style lang="scss">
    @import "../../styles/_variables.scss";

    .loader {
        position: absolute;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        z-index: 2000;
        background: #FFF;

        &.transparent {
            background: transparent;
        }

        &__spinner {
            display: inline-block;
            font-size: 6px;
            position: relative;
            text-indent: -9999em;
            border-top: 0.8em solid $light-blue;
            border-right: 0.8em solid $light-blue;
            border-bottom: 0.8em solid $light-blue;
            border-left: 0.8em solid #ffffff;
            -webkit-transform: translateZ(0);
            -ms-transform: translateZ(0);
            transform: translateZ(0);
            -webkit-animation: load8 0.4s infinite linear;
            animation: load8 0.4s infinite linear;
        }

        &__content {
            top: 50%;
            position: absolute;
            width: 100%;
            text-align: center;
            -webkit-transform: translateY(-50%);
               -moz-transform: translateY(-50%);
                    transform: translateY(-50%);
        }

        &__spinner,
        &__spinner:after {
            border-radius: 50%;
            width: 5em;
            height: 5em;
        }

        &__message {
            font-weight: bold;
            color: $light-blue;
            margin-top: 10px;
        }
    }

    @-webkit-keyframes load8 {
        0% {
            -webkit-transform: rotate(0deg);
                    transform: rotate(0deg);
        }
        100% {
            -webkit-transform: rotate(360deg);
                    transform: rotate(360deg);
        }
    }

    @keyframes load8 {
        0% {
            -webkit-transform: rotate(0deg);
                    transform: rotate(0deg);
        }
        100% {
            -webkit-transform: rotate(360deg);
                    transform: rotate(360deg);
        }
    }
</style>



// WEBPACK FOOTER //
// src/components/general/LoadingSpinner.vue